// extracted by css-extract-rspack-plugin
export default {"clickable":"a5uqCJ","ctrBtn":"Fzz5t7","spacer":"EHDoVL","common":"NlA22n","ctrBtnGroup":"qf2GfO","selected":"Ngi17k"};